import directives from './module';
import {flickityLib} from '../lazy_modules';
import LandingPages from '../LandingPages'

class RelatedPagesSwipable implements ng.IComponentController {
    readonly flicktyPromise: ng.IPromise<any>;
             pagesList: anm.LandingPagesItem[];
             currentUrl: string | ng.ui.IUrlMatcher;

    constructor(private $element: ng.IAugmentedJQuery,
                private $state: ng.ui.IStateService,
                private $q: ng.IQService) {
        this.pagesList      = this.pagesList || LandingPages;
        this.currentUrl     = $state.current.url;
        this.flicktyPromise = !options.handHeld ?
            $q(resolve => loadScripts([flickityLib], resolve)) :
            $q.reject(null);
    }

    $postLink() {
        this.flicktyPromise.then(() => {
            const Flickity = (window as any).Flickity;
            new Flickity(this.$element[0].firstChild, {
                cellSelector: '.help-item',
                prevNextButtons: true,
                wrapAround: true,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false,
                pageDots: false
            });
        });
    }

    getImageUrl(image: string) {
        return require(`../../images/landing/banner/${image}.png`);
    }
}

directives.component('relatedPagesSwipable', {
    bindings: {
        pagesList: '<?'
    },
    controller: RelatedPagesSwipable,
    templateUrl: require('landing/related-pages.html')
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/RelatedPagesSwipable.ts